<template>
  <div class="question-editor">
    <div class="question-pd">
      <!-- 标题头部 -->
      <div class="question-header">
        <div class="question-header-left">
          <div>
            <!-- <span v-if="isMust" class="asterisk">*</span> -->
            <span class="question-number">{{
              `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、`
            }}</span>
          </div>
          <div class="question-select">
            <span>标题</span>
          </div>
        </div>
        <div class="question-header-right">
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596666801.png"
            lazy-load
            class="image-up"
            @click="handleOperateClick(2)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596715787.png"
            lazy-load
            class="image-down"
            @click="handleOperateClick(3)"
          />
          <img
            v-if="type === 1"
            src="https://ossfastmake.mustke.com/qrCode/tupian/1755596748508.png"
            lazy-load
            class="image-delete"
            @click="handleOperateClick(4)"
          />
        </div>
      </div>

      <!-- 文本输入框 -->
      <div
        class="textarea-box"
        style="
          width: 100%;
          background: #ffffff;
          border: 1px solid #dcdde0;
          border-radius: 4px;
          padding: 12px;
          box-sizing: border-box;
          margin-top: 10px;
        "
      >
        <textarea
          placeholder-class="textarea-placeholder"
          v-model="caseProblem"
          placeholder="(一)标题"
          maxlength="500"
          auto-height
          @input="handleInput"
          @focus="isFocusIndex = '-1'"
          @blur="state.isFocusIndex = ''"
          rows="2"
          style="width: 100%; resize: none"
        ></textarea>
        <div
          class=""
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 8px;
          "
        >
          <!-- <img
            src="https://ossfastmake.mustke.com/qrCode/tupian/1737857957020.png"
            mode=""
            style="width: 18px; height: 18px; cursor: pointer"
            @click="handleCaseProblemImg"
          /> -->
          <div></div>
          <div @click="clearQuestion" class="clear-btn">清空</div>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div v-if="type === 1" class="question-footer">
      <div class="save-btn" @click="saveClick">保存</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuestionTitleEditor",
  // Vue2 定义props
  props: {
    params: {
      type: Object,
      default: () => ({}), // 避免对象引用问题
    },
    index: {
      type: Number,
      default: 0,
    },
    updateType: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 1, // 0编辑，1预览
    },
  },
  data() {
    return {
      dataObj: {},
      caseProblem: "",
      isFocusIndex: "", // 聚焦状态标识
      isMust: true, // 默认必填（可根据业务调整）
    };
  },
  // Vue2 监听属性
  watch: {
    // 监听dataObj变化
    params: {
      handler(newValue) {
        console.log("newValue9999999999999999999", newValue);
        this.dataObj = newValue;
        this.caseProblem = newValue.caseProblem || "";
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleOperateClick(type) {
      this.$emit(
        "operate",
        JSON.stringify({
          type: type,
          index: this.index,
        }),
      );
    },
    // 清空输入框
    clearQuestion() {
      this.caseProblem = "";
      this.handleUpdate();
    },
    // 取消按钮
    cancelClick() {
      this.$emit(
        "cancel",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    // 保存按钮
    saveClick() {
      // 赋值并触发保存事件
      this.dataObj.caseProblem = this.caseProblem || "（一）标题";
      this.$emit(
        "save",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
    // 输入更新事件
    handleUpdate() {
      this.dataObj.caseProblem = this.caseProblem;
      this.$emit(
        "update",
        JSON.stringify({
          index: this.index,
          data: this.dataObj,
        }),
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/QuestionEdit/QuestionEditTitle.vue